const convertFaqFromDB = faq => {
  return {
    'id': faq.faq_id,
    'pergunta': faq.question,
    'resposta': faq.answer,
  }
};

export { convertFaqFromDB };
